const config = {
  // Use HTTPS since your site is on HTTPS
  API_URL: process.env.REACT_APP_API_URL || 'https://api.v1.s3dtechnology.in',
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL || 'https://pos.s3dtechnology.in/',
  
  RAZORPAY_KEY: process.env.REACT_APP_RAZORPAY_KEY || 'rzp_test_TGzapDbUo3Jj9t',
  
  IS_PRODUCTION: true,
  IS_TEST_MODE: true,
  APP_NAME: 'Payment System',
  CURRENCY: 'INR',
  CURRENCY_SYMBOL: '₹',
  
  SOCKET_OPTIONS: {
    path: '/socket.io',
    transports: ['polling'],
    upgrade: false,
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 2000,
    timeout: 20000,
    forceNew: true,
    secure: true,  // Enable secure connection
    rejectUnauthorized: false  // Accept self-signed cert
  },
  
  TOAST_CONFIG: {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored"
  }
};

export default config;